import { isMenuScene } from "@components/new_test_ui/new_test_steps/common/DeviceStatus";
import type { DeviceRunState } from "@utils/api-communication/RestApiCli";
import { TestStatus } from "types/testTypes";

export type StartGuardDecision = "send" | "attach" | "refuse";

const RUN_STATUSES_IN_TEST_SCENE = ["started", "running"];

const testIdsStartedOnThisPage = new Set<string>();

export function recordTestStartOnThisPage(testId: string) {
  testIdsStartedOnThisPage.add(testId);
}

export function wasTestStartedOnThisPage(testId: string): boolean {
  return testIdsStartedOnThisPage.has(testId);
}

// Not the scene: 2.8.6 reports Menu once while the Test scene loads, and the
// backend already ends the run of a headset that reconnects in the Menu.
export function runningTestIdOnHeadset(runState: DeviceRunState | null): string | null {
  const run = runState?.activeTestRun;
  return run && RUN_STATUSES_IN_TEST_SCENE.includes(run.status) ? run.uuid : null;
}

// 2.8.6 headsets reload the Test scene for a start with any other uuid and
// abort the test they are running, so such a start is never sent while one runs.
export function decideStartAgainstRunningTest(
  runningTestId: string | null,
  testIdToSend: string,
): StartGuardDecision {
  if (runningTestId === null || runningTestId === testIdToSend) {
    return "send";
  }
  return wasTestStartedOnThisPage(runningTestId) ? "attach" : "refuse";
}

export function sceneOfRunningTest(reportedScene: string | null): string {
  const isLoadingHeartbeat = isMenuScene(reportedScene);
  return reportedScene && !isLoadingHeartbeat ? reportedScene : "Test";
}

export function testStatusForRunningScene(scene: string | null): TestStatus {
  return scene?.toLowerCase() === "virtualassistant"
    ? TestStatus.VirtualAssistant
    : TestStatus.Started;
}

export function forgetTestStartsOnThisPage() {
  testIdsStartedOnThisPage.clear();
}
